export const FrameBuster =()=>{
   //console.log("Validando FRAME");
    
    if (window.top && window !== window.top) {
        window.top.location.href = window.location.href;
      }
}